import { Close, Search } from '@mui/icons-material'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { performSearch, updateQueryLinks } from '../Store/SearchSlice'
import { useAppDispatch, useAppSelector } from '../hooks'
import LanguageSourceTarget from './LanguageSourceTarget'
import { clearHighlights } from '../Store/VocabulariesSlice'

const SearchBar = () => {
  const { t } = useTranslation()

  const dispatch = useAppDispatch()
  const currentVocabulary = useAppSelector((state) => state.vocabularies.currentVocabulary)

  const [query, setQuery] = useState('')
  const [autoSearch, setAutoSearch] = useState(false)

  const clearQuery = () => {
    dispatch(clearHighlights())
    setAutoSearch(true)
    setQuery('')
  }
  useEffect(() => {
    if (autoSearch) {
      setAutoSearch(false)
      executeSearch()
    }
  }, [query])

  const [sourceLanguage, setSourceLanguage] = useState('en')
  const [targetLanguage, setTargetLanguage] = useState('es')

  // Update source and target languages when vocabulary changes
  useEffect(() => {
    if (currentVocabulary && (
      currentVocabulary.left_language !== sourceLanguage ||
      currentVocabulary.right_language !== targetLanguage
    )) {
      setSourceLanguage(currentVocabulary.left_language)
      setTargetLanguage(currentVocabulary.right_language)
      setQuery('')
    }
  }, [currentVocabulary?.left_language, currentVocabulary?.right_language])

  const handleLanguageChange = ({ source, target }: { source: string | null; target: string | null }) => {
    console.log('handleLanguageChange', source, target)
    if (source) {
      setSourceLanguage(source)
    }
    if (target) {
      setTargetLanguage(target)
    }
  }

  // Update query links when query or languages change
  useEffect(() => {
    dispatch(updateQueryLinks({ query, source: sourceLanguage, target: targetLanguage }))
  }, [query, sourceLanguage, targetLanguage, dispatch])

  useEffect(() => {
    executeSearch()
  }, [sourceLanguage, targetLanguage])

  const handleSearch = (event: any = null) => {
    event?.preventDefault()
    executeSearch()
  }
  const executeSearch = () => {
    dispatch(
      performSearch({ query, source: sourceLanguage, target: targetLanguage }),
    )
  }
  const currentSearch = useAppSelector((state) => state.search.currentSearch)
  useEffect(() => {
    if (currentSearch) {
      setQuery(currentSearch.query)
      setSourceLanguage(currentSearch.source)
      setTargetLanguage(currentSearch.target)
    }
  }, [currentSearch])

  return (
    <form onSubmit={handleSearch}>
      <TextField
        type="search"
        value={query}
        placeholder={t('search.placeholder')}
        onInput={(e) => setQuery((e.target as HTMLInputElement).value)}
        sx={{ width: '100%', maxWidth: '500px' }}
        InputProps={{
          endAdornment: (
            <>
              {query && (
                <InputAdornment position="end">
                  <IconButton onClick={clearQuery}>
                    <Close />
                  </IconButton>
                </InputAdornment>
              )}
              <InputAdornment position="end">
                <LanguageSourceTarget
                  sourceLanguage={sourceLanguage}
                  targetLanguage={targetLanguage}
                  onChange={handleLanguageChange}
                />
              </InputAdornment>
              <InputAdornment position="end">
                <IconButton type="submit">
                  <Search />
                </IconButton>
              </InputAdornment>
            </>
          ),
        }}
      />
    </form>
  )
}

export default SearchBar
